import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/AboutPageComponents/StudentWelfarePage/GrievanceRedressalCell/GrievanceRedressalCell.tsx");
